import { Box, BoxProps } from '@mui/material';
import './ccf-box.module.scss';


/**
 * Component used to display box
 * @example <CcfBox />
 * @returns Box
 */
export function CcfBox({children,...other}: BoxProps) {
  return (
    <Box {...other}>
      {children}
    </Box>
  );
}

export default CcfBox;
